{
    "PartitionModal_AddTitle": "Add Partition",
    "PartitionModal_ChangeTitle": "Change Partition",
    "PartitionModal_ViewTitle": "View Partition",
    "PartitionModal_PromptMessage": "You have unsaved partition changes. Exit without saving?",
    "PartitionModal_PromptConfirm": "Exit",
    "PartitionModal_PromptCancel": "Cancel",
    "PartitionModal_Tab_Details": "Details",
    "PartitionModal_Tab_SiteSettings": "Site Settings",
    "PartitionModal_Tab_Synchronisation": "Synchronization",
    "PartitionModal_Tab_Advanced": "Advanced",
    "PartitionModal_Tab_CommunicationStatus": "Sync Status",
    "PartitionModal_Loading": "Loading...",
    "PartitionModal_Button_Close": "Close",
    "PartitionModal_Button_Cancel": "Cancel",
    "PartitionModal_Button_Save": "Save",
    "PartitionModal_RequestFailed": "Request failed",
    "PartitionModal_General_Description": "Description",
    "PartitionModal_General_DescriptionRequired": "Description is required",
    "PartitionModal_General_IDInTelSys": "No. in Telephony Server (Auto)",
    "PartitionModal_General_IDInTelSysRequired": "No. in Telephony Server is required",
    "PartitionModal_General_Tags": "Tag",
    "PartitionModal_Details_Identifier": "Identifier",
    "PartitionModal_Details_IdentifierPlaceholder": "[Auto Assigned]",
    "PartitionModal_Details_BillingIdOrTag": "Billing ID / Tag",
    "PartitionModal_Details_BilledMonthly": "Billed monthly",
    "PartitionModal_Details_LicensedFor": "Licensed for",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "Automatically delete ACD agent entries",
    "PartitionModal_LicensedFor_None": "None",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi ONE",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Enterprise",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Essentials",
    "PartitionModal_LicensedFor_Professional": "Professional",
    "PartitionModal_LicensedFor_CallCentreAgent": "Call Center Agent",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Call Center Supervisor",
    "PartitionModal_Details_CommonDevices": "Contains Common Devices",
    "PartitionModal_Details_CommonDevicesPanasonic": "Contains Common Devices (Common DP Only)",
    "PartitionModal_Details_CommunicationEnabled": "Communication enabled",
    "PartitionModal_Site_Timezone": "Time Zone",
    "PartitionModal_Site_StartOfDay": "Start Of Day (Local Time)",
    "PartitionModal_Site_RecordingPlayback": "Recording Playback",
    "PartitionModal_Site_RecordingPlayback_None": "None",
    "PartitionModal_Site_E164Enabled": "E.164 Enabled",
    "PartitionModal_Site_InternalDigitLength": "Internal Digit Length",
    "PartitionModal_Site_CountryCodeLocation": "Country Code Location",
    "PartitionModal_Sync_NoSettings": "No synchronization settings apply to this telephony server type.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "No synchronization settings apply to a common devices partition.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Name on Telephony Server",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "ID on Telephony Server (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Synchronization Type (Soft Only)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "Enterprise or Provider ID",
    "PartitionModal_Sync_SynchronisationType": "Synchronization Type",
    "PartitionModal_Sync_WebexEnvironmentType": "Webex Environment Type",
    "PartitionModal_Sync_TeamsEnvironmentType": "Teams Environment Type",
    "PartitionModal_Sync_EnterpriseID": "Enterprise ID",
    "PartitionModal_Sync_GroupID": "Group ID",
    "PartitionModal_Sync_UserInLocation": "User in Location",
    "PartitionModal_Sync_IDOnTelephonyServer": "ID on Telephony Server",
    "PartitionModal_Sync_TypeOnTelSys": "Type on Telsys",
    "PartitionModal_Sync_WebexTypeEnvironment": "Webex type environment",
    "PartitionModal_Sync_ComponentType_Unknown": "[Unknown Or Unspecified Type]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Enterprise",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Enterprise Group",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Service Provider",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Service Provider Group",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organization",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Location",
    "PartitionModal_Sync_Environment_None": "None",
    "PartitionModal_Sync_Environment_Tenant": "Tenant",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Authorizer select",
    "PartitionModal_Sync_Environment_SecurityGroups": "Security groups",
    "PartitionModal_Sync_SynchronisationType_Soft": "Soft",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "One-time full",
    "PartitionModal_Sync_SynchronisationType_Full": "Full",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Service pack",
    "PartitionModal_Sync_SecurityGroups": "Security Groups",
    "PartitionModal_Sync_SyncOptions": "Sync options",
    "PartitionModal_Sync_SyncOptions_None": "None",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Endpoints",
    "PartitionModal_Sync_SyncOptions_Trunking": "Trunking",
    "PartitionModal_Sync_SyncOptions_Agents": "Agents + Associated Extensions",
    "PartitionModal_Sync_SyncOptions_Supervisors": "Supervisors",
    "PartitionModal_Sync_MaintainParity": "Maintain parity",
    "PartitionModal_Sync_ForceMonitored": "Forced monitored",
    "PartitionModal_Sync_SupervisorPermissions": "Enable Telephony Server Supervisor Permissions by Default",
    "PartitionModal_Sync_SyncNow": "Sync now",
    "PartitionModal_Sync_PhotoSyncNow": "Photo sync now",
    "PartitionModal_Advanced_CtiLoggingEnabled": "CTI logging",
    "PartitionModal_Advanced_Trunking": "Trunking",
    "PartitionModal_Advanced_TrunkingBurst": "Trunking (Burst)",
    "PartitionModal_Advanced_TrunkingCapacity": "Trunking Capacity",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Trunking Capacity (Burst)",
    "PartitionModal_Advanced_TrunkCapacity": "Trunk Capacity",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Trunk Capacity (Burst)",
    "PartitionModal_CommStatus_SyncStatusTitle": "Sync Status",
    "PartitionModal_CommStatus_SyncLastStarted": "Last started at:",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "Synchronization status / error",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "No synchronization status is available yet.",
    "NAME": "PartitionModal"
}
